import styled, { keyframes } from 'styled-components';

export const scaleOn = keyframes`from {transform: translateX(-50%) scale(1);}to {transform: translateX(-50%) scale(1.2)}`;
export const scaleOff = keyframes`from {transform: translateX(-50%) scale(1.2);}to {transform: translateX(-50%) scale(1)}`;

export const Logo = styled.img`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  transition: .3s;
  animation: ${scaleOff} ${(props) => props.theme.animations.bounce};
  width: 12.2rem;
`;


export const Card = styled.div`
  /* min-width: 33.5rem;
  min-height: 31.7rem; */
  background-color: ${(props) => props.theme.colors.darkBlue};
  border-radius: 1.2rem;
  position: relative;
  overflow: hidden;
  user-select: none;

  &:hover {
    ${Logo} {
      animation: ${scaleOn} ${(props) => props.theme.animations.bounce};
    }
  }
`;

export const Fade = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(30, 30, 39, 0) 0%, ${(props) => props.theme.colors.darkBlue} 100%);
`;

export const Background = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const Hero = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const TipWrapper = styled.div`
  position: absolute;
  top: 1.6rem;
  left: 1.6rem;
  z-index: 5;
`;